import { useIsDeprecated } from '@src/data/selectors/app-config-selectors'
import { useIsIcebergGrDevs } from '@src/providers/UserProvider'

// Heights of the fixed/sticky chrome at the top of the app.
const APP_BAR_HEIGHT = 64
const ALERT_BANNER_HEIGHT = 48

/**
 * Offset a `position: sticky` element needs so it pins under the app bar (and the alert
 * banner, when one is showing) instead of sliding beneath it.
 */
export const useStickyContentTop = (): number => {
  const isIcebergGrDevs = useIsIcebergGrDevs()
  const deprecated = useIsDeprecated()
  const hasAlertBanner = isIcebergGrDevs || (import.meta.env.PROD && deprecated)

  return hasAlertBanner ? APP_BAR_HEIGHT + ALERT_BANNER_HEIGHT : APP_BAR_HEIGHT
}
